import { useLocation } from 'react-router-dom'
import { Construction } from 'lucide-react'
import { NAV, isGroup, isLabel } from '../lib/nav'

function labelFor(pathname: string): string {
  for (const e of NAV) {
    if (isGroup(e)) {
      const hit = e.items.find((i) => i.to === pathname)
      if (hit) return hit.label
    } else if (!isLabel(e) && e.to === pathname) return e.label
  }
  return 'Sezione'
}

export function PlaceholderPage() {
  const { pathname } = useLocation()
  return (
    <div className="w-full p-5">
      <div className="panel flex flex-col items-center justify-center gap-3 py-20 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded border border-ink-200 bg-ink-50 text-ink-400">
          <Construction className="h-6 w-6" />
        </span>
        <div>
          <p className="text-[15px] font-semibold text-ink-800">{labelFor(pathname)}</p>
          <p className="mt-1 text-[13px] text-ink-400">Sezione in arrivo nel rebuild. La dashboard è pronta — questa segue.</p>
        </div>
      </div>
    </div>
  )
}
